var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58203 14.584H10.4154V9.08398H8.58203V14.584ZM9.4987 0.833984C4.4387 0.833984 0.332031 4.94065 0.332031 10.0007C0.332031 15.0607 4.4387 19.1673 9.4987 19.1673C14.5587 19.1673 18.6654 15.0607 18.6654 10.0007C18.6654 4.94065 14.5587 0.833984 9.4987 0.833984ZM9.4987 17.334C5.4562 17.334 2.16536 14.0432 2.16536 10.0007C2.16536 5.95815 5.4562 2.66732 9.4987 2.66732C13.5412 2.66732 16.832 5.95815 16.832 10.0007C16.832 14.0432 13.5412 17.334 9.4987 17.334ZM8.58203 7.25065H10.4154V5.41732H8.58203V7.25065Z",
    fill: "#F1FAEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/info_outline.b0243d9a6ed9278255831e7ce54c6a7b.svg";
export { ForwardRef as ReactComponent };